import React from 'react';
import './DocumentWorkflowStatus.css';

/**
 * Badge de statut pour le workflow des documents
 */
const DocumentWorkflowStatus = ({ status, size = 'normal', showIcon = true }) => {
  const statusConfig = {
    draft: {
      label: 'Brouillon',
      className: 'status-draft',
      icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
      description: 'Document en cours de rédaction'
    },
    pending_signature: {
      label: 'En attente',
      className: 'status-pending',
      icon: 'M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z',
      description: 'En attente de signature'
    },
    signed: {
      label: 'Signé',
      className: 'status-signed',
      icon: 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
      description: 'Document signé électroniquement'
    },
    archived: {
      label: 'Archivé',
      className: 'status-archived',
      icon: 'M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4',
      description: 'Document archivé'
    }
  };

  const config = statusConfig[status] || statusConfig.draft;
  const sizeClass = size === 'small' ? 'size-small' : size === 'large' ? 'size-large' : 'size-normal';

  return (
    <span
      className={`document-workflow-status ${config.className} ${sizeClass}`}
      title={config.description}
    >
      {showIcon && (
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" className="status-icon">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={config.icon} />
        </svg>
      )}
      <span className="status-label">{config.label}</span>
    </span>
  );
};

/**
 * Composant pour afficher le workflow complet avec étapes
 */
export const DocumentWorkflowProgress = ({ currentStatus }) => {
  const workflow = [
    { status: 'draft', label: 'Brouillon' },
    { status: 'pending_signature', label: 'En attente' },
    { status: 'signed', label: 'Signé' },
    { status: 'archived', label: 'Archivé' }
  ];

  const currentIndex = workflow.findIndex(step => step.status === currentStatus);

  return (
    <div className="document-workflow-progress">
      {workflow.map((step, index) => (
        <React.Fragment key={step.status}>
          <div className={`workflow-step ${index <= currentIndex ? 'completed' : ''} ${index === currentIndex ? 'current' : ''}`}>
            <div className="step-indicator">
              {index < currentIndex ? (
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="16" height="16">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              ) : (
                <span>{index + 1}</span>
              )}
            </div>
            <span className="step-label">{step.label}</span>
          </div>
          {index < workflow.length - 1 && (
            <div className={`workflow-connector ${index < currentIndex ? 'completed' : ''}`}></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default DocumentWorkflowStatus;
